import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchChangeOrderDetails } from '../../actions/additional_actions';
import { getDateValue } from '../../utils/date';
import { formatMoney } from '../../utils/budget';

class ChangeOrders extends Component {
    // static PropTypes = {
    //     changeorders: PropTypes.array.isRequired,
    // }

    constructor(props) {
        super(props);

        this.state = {
            contract: {},          
            currentPage: 1,
            itemsPerPage: 5  ,
            desClass: true,    
        }

        this.handleClick = this.handleClick.bind(this);
        this.changeNumItemsShown = this.changeNumItemsShown.bind(this);
        this.changeclass = this.changeclass.bind(this);
    }

    UNSAFE_componentWillMount() {
        const { contract } = this.props;
        this.props.fetchChangeOrderDetails(contract.projectId, contract.contractId);       
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.changeorders !== nextProps.changeorders)
        this.setState({ changeorders: nextProps.changeorders })
        if (this.props.contract.contractId !== nextProps.contract.contractId)
        this.setState({ contract: nextProps.contract })
    }

    handleClick(event) {
        this.setState({
          currentPage: Number(event.target.id)
        });
      } 
    
    changeNumItemsShown(e) {
        if (e.target.value < 2 || e.target.value > this.props.changeorders.length ) {
            // || ((e.target.value > this.props.blueBooks.length/2) && (this.state.currentPage)) )
            //console.log(this.state.currentPage); 
        }
        else {
                this.setState({ itemsPerPage: e.target.value });
                //   console.log(this.state.currentPage);
        }
    }
    
    changeclass(){
        this.setState({ desClass: !this.state.desClass });
    }
  
    render() {
        let { desClass } = '';
        if(this.state.desClass === true) desClass='description';
        else desClass='description-open';
        const { currentPage, itemsPerPage } = this.state;

        // Logic for displaying items
        const indexOfLastItem = currentPage * itemsPerPage;
        const indexOfFirstItem = indexOfLastItem - itemsPerPage;
        const currentChangeOrders= this.props.changeorders.slice(indexOfFirstItem, indexOfLastItem);

        // Logic for displaying page numbers
        const pageNumbers = [];
        for (let i = 1; i <= Math.ceil(this.props.changeorders.length / itemsPerPage); i++) {
            pageNumbers.push(i);
        }

        return (
            <div id="changeorders">
            { currentChangeOrders.length>0?
                <div id="accordiondetails" className="row-wide">
                    <div className="col s12">
                        <div className="dw-table">
                            <table className="table-striped">
                                <thead>
                                    <tr>
                                        <th>CO/OR</th>
                                        <th>Source System</th>
                                        <th>CO #</th>
                                        <th>CO Status</th>
                                        <th>CO Discovery Information</th>
                                        <th>CO Classification</th>
                                        <th>CO Discovery Date</th>
                                        <th>Estimated Amount</th>
                                        <th>Registered Amount</th>
                                        <th>Registered Date</th>
                                        <th>Work Flow Status</th>
                                        <th>Work Flow Status Date</th>
                                    </tr>
                                </thead>

                                <tbody>
                                {  currentChangeOrders.map((co, index) => {   
                                     return <tr key={index}>                            
                                        <td>{co.cOorOR}</td>
                                        <td>{co.src}</td>
                                        <td>{co.coNo}</td>
                                        <td>{co.status}</td>
                                        <td><div className={desClass} onClick={() => this.changeclass()}>{co.coDiscDesc}</div></td>
                                        <td>{co.classification}</td>
                                        <td>{getDateValue(co.coDiscDt)}</td>
                                        <td>{formatMoney(co.coRoughEst)}</td>
                                        <td>{formatMoney(co.pkgRegAmt)}</td>  
                                        <td>{getDateValue(co.pkgRegDt)}</td>  
                                        <td>{co.current_Step}</td>  
                                        <td>{getDateValue(co.step_Date)}</td>                                       
                                    </tr>
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                    {pageNumbers.length > 1 &&
                    <div>
                        <div className="col s12">
                            <div className="controls margin-top-1">
                                <label className="label-pagination">Show</label>
                                <input type="number" value={itemsPerPage} onChange={this.changeNumItemsShown}
                                    min="2" max={this.props.changeorders.length - 1} className="input-pagination" />
                                <span className="label-pagination">Records</span>
                            </div>
                        </div>

                        <div className="col s12">
                            <div className="pagination-blue-book">
                                <ul id="page-numbers">
                                    {pageNumbers.map(number => {
                                        return <li
                                            key={number}
                                            id={number}
                                            onClick={this.handleClick}
                                            className={currentPage === number ? 'active' : ''}
                                        >
                                            {number}
                                        </li>
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                }
                </div> : 
            <div className="noData">
                No Change Orders are found for this contract.
            </div>}
            </div>
        );
    }
}

ChangeOrders.propTypes = {
    changeorders: PropTypes.array.isRequired
  };

function mapStateToProps(state, ownProps) {
    return {
        changeorders: state.additionalProjectsStore.allChangeOrders,
        projectId: ownProps.projectId,       

    };
}

export default connect(mapStateToProps, { fetchChangeOrderDetails })(ChangeOrders);